import React from 'react';
import ReactDOM from 'react-dom/client';
import { AnimatePresence } from 'framer-motion'
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx'
import { TranslateProvider } from './context/TranslateCtx.jsx';
import './index.css'
import { GoogleOAuthProvider } from '@react-oauth/google'
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
 
ReactDOM.createRoot(document.getElementById('root')).render(

  <React.StrictMode>
    <TranslateProvider>
      <AnimatePresence mode="wait">
        <BrowserRouter>
          <GoogleOAuthProvider clientId={googleClientId}>
            <App />
          </GoogleOAuthProvider>
        </BrowserRouter>
      </AnimatePresence>
    </TranslateProvider>
  </React.StrictMode>

)


